import { render, staticRenderFns } from "./SEORecommendationsDashboard.vue?vue&type=template&id=35e27f04&scoped=true"
import script from "./SEORecommendationsDashboard.vue?vue&type=script&lang=js"
export * from "./SEORecommendationsDashboard.vue?vue&type=script&lang=js"
import style0 from "./SEORecommendationsDashboard.vue?vue&type=style&index=0&id=35e27f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e27f04",
  null
  
)

export default component.exports